import { make } from 'vuex-pathify'
import Feedback from '@/api/feedback'

const state = {
  feedback: {}
}

const getters = {
  ...make.getters(state),

  files: (state) => {
    return state.feedback.files || []
  },
  sender: (state) => {
    return state.feedback.user || {}
  }
}

const mutations = {
  ...make.mutations(state)
}

const actions = {
  async show({ commit }, payload) {
    try {
      commit('SET_FEEDBACK', {})
      const response = await Feedback.show(payload.id, payload.params)
      commit('SET_FEEDBACK', response.data.feedback)
      return response
    } catch (e) {
      return false
    }
  },

  async store({ commit }, payload) {
    try {
      commit('SET_FEEDBACK', {})
      const response = await Feedback.store(payload)
      commit('SET_FEEDBACK', response.data.feedback)
      return response
    } catch (e) {
      return false
    }
  },

  async delete({ commit }, id) {
    try {
      const response = await Feedback.delete(id)
      return response
    } catch (e) {
      return false
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
